/**
 * Restore Probiotics — Trustpilot rating injection
 * Voegt een Trustpilot-mention toe rechts naast de sterren-rij,
 * onder de prijs op /products/restore-probiotics.
 *
 * Scoped via product handle in layout/theme.liquid.
 * Idempotent via data-solvey-trustpilot-injected guard op de host.
 */
(function () {
  'use strict';

  var HOST_SELECTOR = '.product__rating-below-price';
  var GUARD_ATTR = 'data-solvey-trustpilot-injected';
  var TRUSTPILOT_URL = 'https://nl.trustpilot.com/review/solveyfem.com';
  var SCORE_TEXT = '4,6/5 op';
  var BRAND_COLOR = '#00B67A'; // Trustpilot green

  function inject(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var hosts = scope.querySelectorAll(HOST_SELECTOR);
    for (var i = 0; i < hosts.length; i++) {
      var host = hosts[i];
      if (host.getAttribute(GUARD_ATTR) === '1') continue;
      host.setAttribute(GUARD_ATTR, '1');

      // Make host a flex container so stars + trustpilot align on one line
      host.style.display = 'flex';
      host.style.alignItems = 'center';
      host.style.flexWrap = 'wrap';
      host.style.gap = '12px';

      var link = document.createElement('a');
      link.href = TRUSTPILOT_URL;
      link.target = '_blank';
      link.rel = 'noopener';
      link.className = 'solvey-trustpilot-mention';
      link.setAttribute('aria-label', '4,6 van 5 op Trustpilot — opent in nieuw tabblad');

      link.innerHTML = '<span class="solvey-trustpilot-text">' + SCORE_TEXT + ' <strong>Trustpilot</strong></span>';

      host.appendChild(link);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { inject(document); });
  } else {
    inject(document);
  }

  var debounceTimer = null;
  var observer = new MutationObserver(function () {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () { inject(document); }, 50);
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
